import { DashboardSendMessages } from '../constants/reports'
import { Ref } from 'react'
import { RichTextField } from '@prismicio/client'

export enum DashboardSlug {
  FLOWCODE_ANALYSIS = 'flowcode-analysis',
  FLOWPAGE_ANALYSIS = 'flowpage-analysis',
  FLOWCODE_FLOWPAGE_ANALYSIS = 'flowcode-flowpage-analysis',
  FLOWCODE_RAW_EVENTS = 'flowcode-raw-events',
  FLOWPAGE_RAW_EVENTS = 'flowpage-raw-events',
  ADMIN_USAGE_REPORT = 'admin-usage-report',
  FLOWCODE_API_ANALYSIS = 'flowcode-api-analysis'
}

export interface ViewableReports {
  [DashboardSlug.FLOWCODE_ANALYSIS]: boolean
  [DashboardSlug.FLOWPAGE_ANALYSIS]: boolean
  [DashboardSlug.FLOWCODE_FLOWPAGE_ANALYSIS]: boolean
  [DashboardSlug.ADMIN_USAGE_REPORT]: boolean
  [DashboardSlug.FLOWCODE_RAW_EVENTS]: boolean
  [DashboardSlug.FLOWPAGE_RAW_EVENTS]: boolean
  [DashboardSlug.FLOWCODE_API_ANALYSIS]: boolean
}

export interface SendDashboardMessage {
  event: DashboardSendMessages
  params?: { [key: string]: string | string[] | undefined }
}

export interface ReportDashboardState {
  isLoading: boolean
  error: boolean
  embedUrl: string | null
  embedIFrameRef: Ref<HTMLIFrameElement>
  sendDashboardMessage: ({ event, params }: SendDashboardMessage) => void
  updateDashboardFiltersFromQuery: () => void
}

type PrismicImage = {
  alt: string
  url: string
  mobile: { alt: string; url: string }
}
export interface PrismicReportItem {
  active: boolean
  coming_soon: boolean
  dashboard_id: RichTextField
  slug: RichTextField
  header: RichTextField
  body1: RichTextField
  icon: { url: string }
  gated_button_cta: RichTextField
  gated_button_link: RichTextField
  gated_copy: RichTextField
}

export interface ReportContent {
  comingSoon: boolean
  id?: string
  slug: string
  header: string
  body: string
  icon: string
  gatedButtonCTA: string
  gatedButtonLink: string
  gatedCopy: string
}

export interface PrismicUpsellBanner {
  icon: PrismicImage
  header: RichTextField
  copy: RichTextField
  button1_cta: RichTextField
  button1_link: RichTextField
  button2_cta: RichTextField
  button2_link: RichTextField
}

export interface UpsellBannerContent {
  icon: PrismicImage
  header: string
  copy: string
  button1Cta: string
  button1Link: string
  button2Cta: string
  button2Link: string
}
